import { Favorite, FavoriteBorder } from '@material-ui/icons';
import { MappingClientT, ObjectContainerClientT, ObjectTypeClientT, ObjectTypePropertyCollectionItemT, StatusClientT } from 'bovaljaren-models';
import React, { ReactElement, useContext } from 'react';
import BrandingService from '../../../../services/branding.service';
import { AppContext } from '../../../../state/app.state';
import { formatValue } from '../../../../utils/object.helper';
import { objectTypePropertySorting } from '../../../../utils/objectType.helper';
import { ObjectSortingT, rejectedObjectListProperties } from '../ObjectList';

type ObjectListBodyProps={
    sorting: ObjectSortingT;
    objects?: ObjectContainerClientT[];
    objectType: ObjectTypeClientT;
    onObjectListRowEnter?: (objectId: number) => void;
    onObjectListRowLeave?: (objectId: number) => void;
    onDataClick: (object: ObjectContainerClientT) => void;
    statuses?: StatusClientT[];
    filterdata: (type: ObjectTypePropertyCollectionItemT) => boolean;
    objectMappings?: MappingClientT[];
};

const ObjectListBody: React.FC<ObjectListBodyProps> = ({ sorting, objects, objectType, onObjectListRowEnter, onObjectListRowLeave, onDataClick, statuses, filterdata }): ReactElement => {
    const { favoriteState, state } = useContext(AppContext);

    const renderFavouriteColumn = (object: ObjectContainerClientT): ReactElement => {
        return favoriteState?.objectIds.some(id => id === object.id) ?
            <Favorite onClick={(): void => favoriteState?.removeFavorite(object.id)}/> :
            <FavoriteBorder onClick={(): void => favoriteState?.addFavorite(object.id)}/>;
    };

    const sortObjects = (a: ObjectContainerClientT, b: ObjectContainerClientT): number => {

        if (!sorting.sort || !sorting.column) return 0;

        if (sorting.column.type === 'name') {
            return (sorting.order ? a.name.toString().localeCompare(b.name.toString()) : b.name.toString().localeCompare(a.name.toString()));
        }
        else {
            const aValue = a.data.find(d => d.propId === sorting.column?.id)?.value;
            const bValue = b.data.find(d => d.propId === sorting.column?.id)?.value;

            if (!aValue || !bValue) return 0;

            if (sorting.column.baseType === 'string') {
                return (sorting.order ? aValue.toString().localeCompare(bValue.toString()) : bValue.toString().localeCompare(aValue.toString()));
            }

            else if (sorting.column.baseType === 'number') {
                const aNumber = Number(aValue);
                const bNumber = Number(bValue);

                if (isNaN(aNumber) || isNaN(bNumber)) return 0;

                return sorting.order ? (aNumber - bNumber) : (bNumber - aNumber);
            }

            return 0;
        }
    };

    return (
        <tbody className={'bv-object-list-body'}>
            {objects?.slice().sort(sortObjects)
                .map((o, i) => {
                    return (
                        <tr
                            onMouseOver={(): void => {
                                onObjectListRowEnter && onObjectListRowEnter(o.id);
                            }}
                            onMouseOutCapture={(): void => {
                                onObjectListRowLeave && onObjectListRowLeave(o.id);
                            }}
                            className={'bv-object-list-row'}
                            key={i}>
                            <td onClick={(): void => onDataClick && onDataClick(o)} ><div className={`bv-${statuses?.find(s => s.id === o.statusId)?.type } bv-object-list-status bv-td-status-spacer`}/></td>
                            <td onClick={(): void => onDataClick && onDataClick(o)} className={'bv-object-list-identifier bv-object-list-cell'}>{o.name}</td>

                            {objectType.properties
                                .filter(p => filterdata(p))
                                .filter(p => !rejectedObjectListProperties.find(rOLP => rOLP === p.type))
                                .sort(objectTypePropertySorting)
                                .map((t, index) => {
                                    let data = o.data.find(d => d.propId === t.id);

                                    if (o.objectTypeId !== objectType.id) {
                                        const propertyId = state?.project?.objectTypes.find(oT => oT.id === o.objectTypeId)?.properties.find(p => p.type === t.type && p.baseType === t.baseType && p.name === t.name)?.id;

                                        data = (propertyId && o.data.find(d => d.propId === propertyId)) || undefined;
                                    };

                                    return <td onClick={(): void => onDataClick && onDataClick(o)} className={'bv-object-list-cell'} key={index}>{data ? formatValue(data, t.type) : ''}</td>;
                                })}
                            {state?.project?.config?.favorites &&
                                    <td className={'bv-object-list-favourite'}>
                                        {renderFavouriteColumn(o)}
                                    </td>}
                        </tr>);
                })}
        </tbody>
    );
};


export default ObjectListBody;